import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/index';
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "content-box pt-6"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "form-list mt-6 mb-6"
};
const _hoisted_5 = {
  class: "mb-4"
};
const _hoisted_6 = {
  class: "label"
};
const _hoisted_7 = {
  class: "value"
};
const _hoisted_8 = {
  class: "mb-4 flex items-center"
};
const _hoisted_9 = {
  class: "label"
};
const _hoisted_10 = {
  class: "flex flex-1 justify-between"
};
const _hoisted_11 = {
  class: "flex items-center gap-1"
};
const _hoisted_12 = {
  class: "text-[13px]"
};
const _hoisted_13 = ["href"];
const _hoisted_14 = {
  key: 1,
  class: "text-[12px] text-red-500"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  style: {
    "height": "505px",
    "overflow": "auto"
  }
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  class: "mainWord"
};
const _hoisted_20 = {
  key: "0"
};
const _hoisted_21 = {
  class: "h-7 leading-7 rounded-none bg-[#cbeeff] text-[#409eff]"
};
const _hoisted_22 = {
  key: "1"
};
const _hoisted_23 = {
  class: "h-7 leading-7 rounded-none bg-[#cbeeff] text-[#409eff]"
};
const _hoisted_24 = {
  key: "2"
};
const _hoisted_25 = {
  class: "h-7 leading-7 rounded-none bg-[#cbeeff] text-[#409eff]"
};
const _hoisted_26 = ["innerHTML"];
const _hoisted_27 = {
  key: 0,
  class: "media"
};
const _hoisted_28 = ["href"];
const _hoisted_29 = {
  style: {
    "height": "33px",
    "line-height": "33px",
    "border-radius": "5px",
    "background-color": "#cbeeff",
    "color": "#409eff",
    "display": "inline-block",
    "padding": "0px 10px"
  }
};
import { ref, computed, reactive } from 'vue';
import { InfoFilled } from '@element-plus/icons-vue';
// @ts-ignore
import SpotItem from '@/views/components/SpotItem.vue';
import { downloadFile } from '@/utils/file-helpers';
import CenterDialog from '@components/CenterDialog.vue';
import useMedia from './hooks/useMedia';
import { getMedia, getYdylMedia, getShopNews, GetShopNewsPublishResult, exportPublishResult } from '../../api/media';
export default /*@__PURE__*/_defineComponent({
  __name: 'DetailDialog',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const {
      approvalOptions,
      getStatus
    } = useMedia();
    const info = reactive({
      model: null,
      detail: null,
      edit: false,
      NewsID: null
    });
    const props = __props;
    const visible = ref(false);
    const loading = ref(false);
    const downloading = ref(false);
    const refreshLoading = ref(false);
    const publishResult = ref([]);
    const rowData = ref(null);
    const approvalStatusAlias = computed(() => {
      const approval = getStatus(info.model.AuditStatus);
      return approval?.alias || approval?.label || '温馨提示';
    });
    const approvalStatusTip = computed(() => {
      const approval = getStatus(info.model.AuditStatus);
      return approval?.tip;
    });
    const apiObj = {
      4: getShopNews,
      10: getYdylMedia
    };
    const loadMediaDetails = async row => {
      loading.value = true;
      try {
        const postData = props.type == 4 ? {
          newsID: row.NewsID
        } : {
          mediaID: row.MediaID
        };
        const func = apiObj[props.type] || getMedia;
        const e = await func(postData);
        if (props.type == 4) {
          // 联盟新闻
          if (e.data.AuditStatus == 1) {
            // 联盟新闻和其他不同 1就算已发布了
            e.data.AuditStatus = 2;
          }
          e.data.model = {
            AuditStatus: e.data.AuditStatus,
            Remark: e.data.Remark,
            Title: e.data.Title
          };
          GetShopNewsPublishResult({
            newsID: row.NewsID
          }).then(res => {
            publishResult.value = res.data.detail;
          });
        }
        Object.assign(info, e.data);
        visible.value = true;
      } finally {
        loading.value = false;
      }
    };
    const handleDownload = async row => {
      if (downloading.value) return;
      downloading.value = true;
      try {
        await downloadFile(row.FileUrl, row.Title || 'download');
      } finally {
        downloading.value = false;
      }
    };
    const handleRefresh = async () => {
      refreshLoading.value = true;
      try {
        const e = await getMedia({
          mediaID: rowData.value.MediaID,
          isRef: true
        });
        Object.assign(info, e.data);
        ElMessage.success('刷新成功');
      } finally {
        refreshLoading.value = false;
      }
    };
    function excel(blob, fileName) {
      function isIE() {
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
          return true;
        }
        return false;
      }
      if (isIE()) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
    }
    const handleExportPublishResult = async () => {
      downloading.value = true;
      exportPublishResult({
        newsID: info.NewsID
      }).then(e => {
        const blob = new Blob([e.data]);
        const fileName = '新闻发布结果明细.xls';
        excel(blob, fileName);
      }).finally(() => {
        downloading.value = false;
      });
    };
    const getPublishUrl = item => {
      if (item.SiteName === '宝发网' && info.NewsID) {
        return `${item.URL}showinfo-${info.NewsID}`;
      }
      return item.URL;
    };
    const openDialog = row => {
      rowData.value = row;
      loadMediaDetails(row);
    };
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_el_alert = _resolveComponent("el-alert");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(CenterDialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => visible.value = $event),
        onClose: _cache[3] || (_cache[3] = $event => visible.value = false),
        title: "查看详情",
        width: "800px"
      }, {
        default: _withCtx(({
          maxHeight
        }) => [_createElementVNode("div", {
          class: "bg-white px-6 pb-6 overflow-y-auto",
          style: _normalizeStyle({
            maxHeight: maxHeight - 24 + 'px'
          })
        }, [props.type != 4 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_alert, {
          "show-icon": "",
          type: "primary",
          closable: false
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(approvalStatusAlias.value) + "： ", 1), info.model.AuditStatus === -1 ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(info.model.Remark), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(approvalStatusTip.value), 1))]),
          _: 1
        }), _createElementVNode("ul", _hoisted_4, [_createElementVNode("li", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(props.type == '9' ? '视频标题' : '新闻标题') + "：", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(info.model?.Title), 1)]), _createElementVNode("li", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(props.type == '9' ? '视频' : '文案') + "：", 1), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => handleDownload(info.model)),
          type: "primary",
          link: "",
          class: "py-0"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 下载 ", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: refreshLoading.value,
          onClick: handleRefresh,
          type: "primary",
          link: "",
          class: "py-0"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("刷新", -1)]))]),
          _: 1
        }, 8, ["loading"])])])]), _createElementVNode("div", null, [_createVNode(_component_el_table, {
          data: info.detail
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "Title",
            label: "提交媒体",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "AddDate",
            label: "提交时间",
            width: "160",
            align: "center",
            "header-align": "center"
          }), _createVNode(_component_el_table_column, {
            prop: "UpdateDate",
            label: "状态变更时间",
            width: "160",
            align: "center",
            "header-align": "center"
          }), _createVNode(_component_el_table_column, {
            prop: "AuditStatus",
            label: "状态",
            width: "104"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", _hoisted_11, [_createVNode(SpotItem, {
              list: _unref(approvalOptions),
              value: row.AuditStatus
            }, null, 8, ["list", "value"]), row.Remark ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              placement: "top"
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_icon, {
                color: "#ccc"
              }, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(row.Remark), 1)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "120",
            align: "center",
            "header-align": "center"
          }, {
            default: _withCtx(scope => [scope.row.AuditStatus == 2 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "text",
              size: "small"
            }, {
              default: _withCtx(() => [_createElementVNode("a", {
                href: scope.row.ResultUrl,
                target: "_blank"
              }, "查看", 8, _hoisted_13)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), scope.row.oldResultUrl && scope.row.ResultUrl != scope.row.oldResultUrl ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(有更新)")) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])])])), [[_directive_loading, loading.value]]) : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_alert, {
          "show-icon": "",
          type: "primary",
          closable: false
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(approvalStatusAlias.value) + "： ", 1), info.model.AuditStatus === -1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(info.Remark), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(approvalStatusTip.value), 1))]),
          _: 1
        }), _createVNode(_component_el_form, {
          model: info,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "新闻标题："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(info.Title), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "关键词："
          }, {
            default: _withCtx(() => [_createElementVNode("ul", _hoisted_19, [info.SeoKeyword1 != '' ? (_openBlock(), _createElementBlock("li", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(info.SeoKeyword1), 1)])) : _createCommentVNode("", true), info.SeoKeyword2 != '' ? (_openBlock(), _createElementBlock("li", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(info.SeoKeyword2), 1)])) : _createCommentVNode("", true), info.SeoKeyword3 != '' ? (_openBlock(), _createElementBlock("li", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(info.SeoKeyword3), 1)])) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新闻来源："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(info.Source), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "作者："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(info.Author), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新闻内容："
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: info.Content,
              class: "iframe-content"
            }, null, 8, _hoisted_26)]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), info.AuditStatus == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("p", null, [_createTextVNode(" 已完成媒体（" + _toDisplayString(publishResult.value.length) + "个） ", 1), _createVNode(_component_el_button, {
          type: "text",
          loading: downloading.value,
          class: "float-right mr-4",
          onClick: _cache[1] || (_cache[1] = $event => handleExportPublishResult(info))
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 导出excel表格 ", -1)]))]),
          _: 1
        }, 8, ["loading"])]), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publishResult.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.SiteName
          }, [_createElementVNode("a", {
            href: getPublishUrl(item),
            target: "_blank"
          }, [_createElementVNode("span", _hoisted_29, _toDisplayString(item.SiteName), 1)], 8, _hoisted_28)]);
        }), 128))])])) : _createCommentVNode("", true)])])), [[_directive_loading, loading.value]])], 4)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});